// Business contact information
export const PHONE_NUMBER = '9996212490';
export const PHONE_NUMBER_WITH_PREFIX = '+919996212490';

// WhatsApp configuration
export const WHATSAPP_DEFAULT_MESSAGE = 'Hi Shivay Durga Foods, \nI have a question about your menu and delivery options.';
export const getWhatsAppLink = (message = WHATSAPP_DEFAULT_MESSAGE) => {
  return `https://api.whatsapp.com/send?phone=91${PHONE_NUMBER}&text=${encodeURIComponent(message)}`;
};
